import type { CSSProperties, ReactElement } from 'react';

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string;
}

/** Matches the final layout's shape. Spinners are for buttons, not content. */
export function Skeleton({ width = '100%', height = 16, radius }: SkeletonProps): ReactElement {
  const style: CSSProperties = { width, height };
  if (radius !== undefined) style.borderRadius = radius;
  return <span className="skeleton" style={style} aria-hidden="true" />;
}

export function LoadingState({
  rows = 3,
  label = 'Loading',
}: {
  rows?: number;
  label?: string;
}): ReactElement {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}
    >
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={i === 0 ? 24 : 16} width={i === 0 ? '40%' : '100%'} />
      ))}
    </div>
  );
}
